var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "form-inbox" } },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "pagination-controls" }, [
          _c("div", { staticClass: "pagination-buttons" }, [
            _c(
              "button",
              {
                staticClass: "page-btn prev-btn",
                attrs: { disabled: _vm.answersData.currentPage === 1 },
                on: { click: _vm.prevPage },
              },
              [
                _c("md-icon", { staticClass: "icon" }, [
                  _vm._v("chevron_left"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "page-info" }, [
              _c("span", { staticClass: "current-page" }, [
                _vm._v(_vm._s(_vm.answersData.currentPage)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "separator" }, [_vm._v("/")]),
              _vm._v(" "),
              _c("span", { staticClass: "total-pages" }, [
                _vm._v(_vm._s(_vm.answersData.totalPages)),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "page-btn next-btn",
                attrs: {
                  disabled:
                    _vm.answersData.currentPage >= _vm.answersData.totalPages,
                },
                on: { click: _vm.nextPage },
              },
              [
                _c("md-icon", { staticClass: "icon" }, [
                  _vm._v("chevron_right"),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "page-size-selector" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localPageSize,
                    expression: "localPageSize",
                  },
                ],
                staticClass: "page-size-select",
                on: {
                  change: [
                    function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.localPageSize = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.changePageSize,
                  ],
                },
              },
              [
                _c("option", { attrs: { value: "5" } }, [_vm._v("5")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "10" } }, [_vm._v("10")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "20" } }, [_vm._v("20")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "50" } }, [_vm._v("50")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "100" } }, [_vm._v("100")]),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "page-size-label" }, [
              _vm._v(_vm._s(_vm.$t("form.itemsPerPage"))),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header-items-group" },
          [
            _c(
              "div",
              {
                staticClass: "header-item",
                on: {
                  click: function ($event) {
                    return _vm.$router.push({
                      path: "/form",
                      query: { type: "list" },
                    })
                  },
                },
              },
              [
                _c("md-icon", { staticClass: "icon" }, [_vm._v("arrow_back")]),
                _vm._v(" "),
                _c("span", { staticClass: "header-text" }, [
                  _vm._v(_vm._s(_vm.$t("message.back"))),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "header-item",
                attrs: { "data-active": _vm.filterStatus === "all" },
                on: {
                  click: function ($event) {
                    return _vm.filterStatusForm("all")
                  },
                },
              },
              [
                _c("md-icon", { staticClass: "icon" }, [_vm._v("all_inbox")]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "header-text",
                    attrs: { "data-count": _vm.totalSubmissions },
                  },
                  [_vm._v("\n                    Tümü\n                ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "header-item",
                attrs: { "data-active": _vm.filterStatus === "notRead" },
                on: {
                  click: function ($event) {
                    return _vm.filterStatusForm("notRead")
                  },
                },
              },
              [
                _c("md-icon", { staticClass: "icon" }, [_vm._v("inbox")]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "header-text",
                    attrs: { "data-count": _vm.answersData.notRead },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("form.inbox")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "header-item",
                attrs: { "data-active": _vm.filterStatus === "read" },
                on: {
                  click: function ($event) {
                    return _vm.filterStatusForm("read")
                  },
                },
              },
              [
                _c("md-icon", { staticClass: "icon" }, [_vm._v("send")]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "header-text",
                    attrs: { "data-count": _vm.answersData.read },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("form.read")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "header-item",
                attrs: { "data-active": _vm.filterStatus === "archive" },
                on: {
                  click: function ($event) {
                    return _vm.filterStatusForm("archive")
                  },
                },
              },
              [
                _c("md-icon", { staticClass: "icon" }, [_vm._v("archive")]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "header-text",
                    attrs: { "data-count": _vm.answersData.archive },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("chatbotv2.archive")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "header-item",
                attrs: { "data-active": _vm.filterStatus === "ticket" },
                on: {
                  click: function ($event) {
                    return _vm.filterStatusForm("ticket")
                  },
                },
              },
              [
                _c("md-icon", { staticClass: "icon" }, [
                  _vm._v("confirmation_number"),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "header-text",
                    attrs: { "data-count": _vm.answersData.ticket },
                  },
                  [
                    _vm._v(
                      "\n                    Ticket'dan Kapanan\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("a-popover", {
              attrs: { placement: "bottomRight", trigger: "click" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "header-item" },
                        [
                          _c("md-icon", { staticClass: "icon" }, [
                            _vm._v("download"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "header-text" }, [
                            _vm._v(_vm._s(_vm.$t("report.download"))),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function ($event) {
                              return _vm.handleEmailDownload("all")
                            },
                          },
                        },
                        [
                          _c("md-icon", { staticClass: "icon" }, [
                            _vm._v("email"),
                          ]),
                          _vm._v(
                            "\n                        Tüm Veriyi Email ile Gönder\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.selectedAnswer && _vm.selectedAnswer.submission
                        ? _c(
                            "div",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  return _vm.handleEmailDownload("selected")
                                },
                              },
                            },
                            [
                              _c("md-icon", { staticClass: "icon" }, [
                                _vm._v("email"),
                              ]),
                              _vm._v(
                                "\n                        Seçili Veriyi Email ile Gönder\n                    "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-item",
                          class: {
                            disabled:
                              !_vm.selectedAnswer ||
                              !_vm.selectedAnswer.submission,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleDirectDownload("selected")
                            },
                          },
                        },
                        [
                          _c("md-icon", { staticClass: "icon" }, [
                            _vm._v("download"),
                          ]),
                          _vm._v(
                            "\n                        Seçili Veriyi Hemen İndir\n                        "
                          ),
                          !_vm.selectedAnswer || !_vm.selectedAnswer.submission
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#999",
                                    "font-size": "11px",
                                  },
                                },
                                [_vm._v(" (Önce bir yanıt seçin)")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-inbox-container" }, [
        _c(
          "div",
          { staticClass: "inbox-menu" },
          [
            !_vm.loading
              ? _c("InboxMenu", {
                  attrs: {
                    answersData: _vm.answersData,
                    "selected-submission-id":
                      _vm.selectedAnswer &&
                      _vm.selectedAnswer.submission &&
                      _vm.selectedAnswer.submission._id,
                  },
                  on: { "item-selected": _vm.formAnswers },
                })
              : _c("div", { staticClass: "spinner" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "spinner-icon",
                      attrs: {
                        width: "50px",
                        height: "50px",
                        viewBox: "0 0 50 50",
                      },
                    },
                    [
                      _c("circle", {
                        staticClass: "path",
                        attrs: {
                          cx: "25",
                          cy: "25",
                          r: "20",
                          fill: "none",
                          "stroke-width": "5",
                        },
                      }),
                    ]
                  ),
                ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "inbox-content" },
          [
            _vm.selectedAnswer && _vm.selectedAnswer.submission
              ? _c("InboxContents", {
                  key:
                    _vm.selectedAnswer.submission._id +
                    this.answersData.currentPage,
                  attrs: {
                    "submission-id": _vm.selectedAnswer.submission._id,
                    "not-read-btn": _vm.notReadBtn,
                    archiveBTN: _vm.archiveBTN,
                  },
                  on: { "mark-as-read": _vm.updateData },
                })
              : _c(
                  "div",
                  { staticClass: "no-data" },
                  [
                    _c("md-icon", { staticClass: "md-icon" }, [_vm._v("info")]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("form.selectItemToViewDetails")) +
                        "\n            "
                    ),
                  ],
                  1
                ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: "Excel İndir", footer: null, width: 400 },
          on: { cancel: _vm.cancelDownloadModal },
          model: {
            value: _vm.showDownloadModal,
            callback: function ($$v) {
              _vm.showDownloadModal = $$v
            },
            expression: "showDownloadModal",
          },
        },
        [
          _c("div", { staticClass: "excel-download-modal" }, [
            _c("div", { staticClass: "download-options" }, [
              _c("div", { staticClass: "option-title" }, [
                _vm._v("Excel dosyasını nasıl almak istersiniz?"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "option-item",
                  on: {
                    click: function ($event) {
                      return _vm.selectOption("self")
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "option-radio" },
                    [
                      _c("a-radio", {
                        attrs: { checked: _vm.selectedOption === "self" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "option-content" }, [
                    _c("div", { staticClass: "option-label" }, [
                      _vm._v("Bana Gönder"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "option-description" }, [
                      _vm._v(_vm._s(_vm.user.email)),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "option-item",
                  on: {
                    click: function ($event) {
                      return _vm.selectOption("other")
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "option-radio" },
                    [
                      _c("a-radio", {
                        attrs: { checked: _vm.selectedOption === "other" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "option-content" }, [
                    _c("div", { staticClass: "option-label" }, [
                      _vm._v("Başkasına Gönder"),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.selectedOption === "other"
                ? _c(
                    "div",
                    { staticClass: "email-input-area" },
                    [
                      _c("a-input", {
                        staticClass: "custom-email-input",
                        attrs: { placeholder: "Email adresi girin" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "prefix",
                              fn: function () {
                                return [
                                  _c("a-icon", {
                                    staticStyle: { color: "rgba(0,0,0,.25)" },
                                    attrs: { type: "mail" },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1015637592
                        ),
                        model: {
                          value: _vm.customEmail,
                          callback: function ($$v) {
                            _vm.customEmail = $$v
                          },
                          expression: "customEmail",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c("a-button", { on: { click: _vm.cancelDownloadModal } }, [
                  _vm._v("İptal"),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "submit-button",
                    attrs: {
                      type: "primary",
                      disabled: !_vm.isValidEmailSelected,
                    },
                    on: { click: _vm.submitEmailRequest },
                  },
                  [_vm._v("\n                    Gönder\n                ")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }